import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchSidepanelWrapper from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-sidepanel-wrapper/grossing-touch-sidepanel-wrapper.vue'
import PriorityDot from '@/modules/clinicalModule/components/StatusRequestPriorityDot.vue'

@Component({
    components: {
        GrossingTouchSidepanelWrapper,
        PriorityDot
    }
})

export default class GrossingTouchAssaysSidepanel extends Vue {
    private grossingAssays !: Array<object>
    private protocolSelectionBarActive !: Boolean
    private prioritySelected !: string

    constructor() {
        super()
        this.protocolSelectionBarActive = false
        this.prioritySelected = 'normal-priority'
        this.grossingAssays = [
            {
                name: 'ACTH (H. Adrenocorticotropa)',
                assayGroup: {
                    name: 'Inmunohistoquímica'
                }
            },
            {
                name: 'Adipofilina',
                assayGroup: {
                    name: 'Inmunohistoquímica'
                }
            },
            {
                name: 'Albumina (FITC)',
                assayGroup: {
                    name: 'Inmunohistoquímica'
                }
            },
            {
                name: 'Anexinaa (29)',
                assayGroup: {
                    name: 'Inmunohistoquímica'
                }
            }
        ]
    }
}
